import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'app-services',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
    ],
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.css']
})
export class ServicesComponent {
    // Opcional: Puedes usar esto si quieres poner un menú lateral o superior 
    // dentro de esta misma página para navegar entre servicios fácilmente
    servicesMenu = [
        { label: 'Financiamiento', path: '/servicios/financiamiento' },
        { label: 'Tesorería', path: '/servicios/tesoreria' },
        { label: 'External CFO', path: '/servicios/external-cfo' },
        { label: 'Capacitación', path: '/servicios/capacitacion' },
        { label: 'COMEX', path: '/servicios/comex' },
        { label: 'Consultoría Fiscal', path: '/servicios/consultoria-fiscal' },
        { label: 'Servicios Especializados', path: '/servicios/servicios-especializados' }
    ];
}